import React from "react";
import ReactDOM from "react-dom";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";
import AlertThresholdModal from "./index";

export default async function renderAlertThresholdModal({
  target = "modal-container",
  alertThreshold = MonetaryAmount.ZERO,
  alertThresholdEmails = [],
  ...rest
} = {}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(
      <AlertThresholdModal
        alertThreshold={alertThreshold}
        alertThresholdEmails={alertThresholdEmails}
        {...rest}
      />,
      domTarget
    );
  }
}
